export const campaignRebuildKeys = {
  rebuildData: (campaignId: number) => ['/api/campaigns', campaignId, 'rebuild-data'] as const,
  rebuildEligibility: (campaignId: number) => ['/api/campaigns', campaignId, 'rebuild-eligibility'] as const,
};
